import React from 'react'
import { textStyles } from '@marketing-sites/ui'
import type { RelatedArticleItemFragment } from '../../../.graphql/generated-types'
import { ContentfulImageWithPlaceholder } from '../ContentfulImageWithPlaceholder'
import { LinkToArticlePage } from '../LinkToArticlePage'

export interface RelatedArticleItemProps {
  data: RelatedArticleItemFragment
}

export function RelatedArticleItem({ data }: RelatedArticleItemProps) {
  const article = data
  const name = data.name ?? ''
  const imageAsset = article.heroImage?.imageAsset
  if (article.slug) {
    return (
      <li className="flex w-full flex-col border border-blog-dusty-black-100">
        <div className="md:flex">
          {imageAsset?.url && (
            <LinkToArticlePage
              article={article}
              className="relative block h-44 w-full md:h-36 md:w-2/5"
            >
              <ContentfulImageWithPlaceholder
                src={imageAsset.url}
                alt={article.heroImage?.altText ?? ''}
                width={356}
                height={176}
                fill
                sizes="100vw"
                className="object-cover"
              />
            </LinkToArticlePage>
          )}
          <div className="flex min-h-[100px] flex-col justify-between p-4 md:w-3/5">
            <h3
              className={`${textStyles.h3} text-blog-link-blue hover:text-blog-link-blue-hover`}
            >
              <LinkToArticlePage article={article}>
                {article.name ?? ''}
              </LinkToArticlePage>
            </h3>

            <p className="self-end">
              <LinkToArticlePage
                article={article}
                className={`${textStyles.a} underline`}
              >
                <span aria-label={`Read the article - ${name}`}>
                  Read the Article
                </span>
              </LinkToArticlePage>
            </p>
          </div>
        </div>
      </li>
    )
  }
  return null
}
